import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';

import LogoGif from '#/assets/img/loader-nexti.gif';
import styles from './styles.module.css';

const getDefaultLoader = () => (
  <div className={styles.loader} data-testid="default-loader">
    <div className={styles.load} />
  </div>
);

const getSmallLoader = () => (
  <div data-testid="small-loader">
    <div className={styles.smallLoad} />
  </div>
);

const getContentLoader = () => {
  const result = [];
  for (let i = 0; i < 10; i++) {
    result.push(
      <div className={styles.contentLoader} key={i}>
        <ContentLoader height={112} width={400} speed={2}>
          <rect x="29" y="25" rx="0" ry="0" width="80" height="80" />
          <rect x="150" y="25" rx="0" ry="0" width="220" height="26" />
          <rect x="150" y="66" rx="0" ry="0" width="220" height="15" />
          <rect x="150" y="90" rx="0" ry="0" width="220" height="15" />
        </ContentLoader>
      </div>
    );
  }
  return result;
};

const getFullScreenLoader = () => (
  <div className={styles.fullScreen} data-testid="fullScreen-loader">
    <img src={LogoGif} alt="Logo nexti gif" className={styles.logo} />
  </div>
);

const loading = {
  default: getDefaultLoader(),
  content: getContentLoader(),
  fullScreen: getFullScreenLoader(),
  small: getSmallLoader(),
};

const Loader = ({ shape }) => (
  <div className={styles.innerWrapper} data-testid="content-loader">
    {loading[shape]}
  </div>
);

Loader.propTypes = {
  shape: PropTypes.string,
};

Loader.defaultProps = {
  shape: 'default',
};

export default Loader;
